import React from 'react'

import PropTypes from 'prop-types'

import FormBodyType from './index.js'

const FormSingleBodyType = ({value = [], onChange}) => {
  return <FormBodyType value={value} onChange={onChange} singleSelection />
}

FormSingleBodyType.displayName = 'FormSingleBodyType'
FormSingleBodyType.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired
}

const MemoFormFormSingleBodyType = React.memo(FormSingleBodyType)
MemoFormFormSingleBodyType.displayName = 'MemoFormFormSingleBodyType'

export default MemoFormFormSingleBodyType
